
class NewAddOnsUIManager {
  constructor(sectionID) {
    this.variantSelected = false;
    this.includeAddOnsFirstClick = true;
    this.updateAddOnsFirstRun = true;

    this.section = document.getElementById(sectionID);
    // this.expandButton = this.section.querySelectorAll('.add-addons');
    this.expandButton = this.section.querySelectorAll('.trellis-add-ons__button-wrapper button');
    this.productOptions = this.section.closest('form').querySelectorAll('.product-options .product-option');
    this.collapseButton = this.section.querySelectorAll('.button--collapse');
    this.addOnsContainers = this.section.querySelectorAll('.product-add-on');
    this.removeButtons = this.section.querySelectorAll('.remove-addons');
    this.addOnPriceNode = this.section.querySelector('span.price[data-addons-price]');
    this.addOnsBanner = this.section.querySelector('.trellis-add-ons--banner');
    this.variantOptionTriggers = document.querySelectorAll("[data-variant-option-trigger]");
    this.bannerItems = this.addOnsBanner.querySelectorAll('.addon-banner--selection');
    this.addonInputs = this.section.querySelectorAll('[data-addon-product]');
    this.selectedAddOnsObject = {};
    this.addDeclineButtonWrappers = this.section.querySelectorAll('.trellis-add-ons__button-wrapper');
    this.includeAddOnsButton = this.section.querySelector("#addon_product");
    this.atcDummyButton = document.querySelector('#dummy-atc');
    this.atcRealButton = document.querySelector('#product--right_button-atc');
    this.priceContainerProduct = document.querySelector('[data-price]');
    this.priceContainerAddOns = this.section.querySelector('[data-addons-price]');

    this._priceUpdateRunning = false;
    this._priceUpdateTimer = null;

    this.addOnObserver = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          this.updateAddOnPricing();
          this.updateAddOnsBanner();
        }
      }
    });

    this.init();
  }

  init() {
    this.expandButton.forEach(button => {
      button.addEventListener('click', (event) => {
        let allSelected = true;
        let firstUnselectedOption = null;

        this.productOptions.forEach(option => {
          const title = option.querySelector('.option-title span')?.textContent?.trim();
          const radios = option.querySelectorAll('input[type="radio"]');
          const selected = option.querySelector('input[type="radio"]:checked');
          option.querySelector('.option-warning')?.remove();

          if (radios.length && !selected) {
            if (!firstUnselectedOption) firstUnselectedOption = option;
            allSelected = false;

            const msg = document.createElement('span');
            msg.className = 'option-warning';
            msg.style.color = 'red';
            msg.textContent = `Please select a ${title}`;
            option.prepend(msg);

            radios.forEach(input => {
              input.addEventListener('change', () => {
                option.querySelector('.option-warning')?.remove();
                this.getMatchedVariantAndUpdateSelects();
              }, { once: true });
            });
          }
        });

        if (allSelected) {
          this.handleExpandButtonClick(event);
        } else if (firstUnselectedOption) {
          firstUnselectedOption.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });

    this.collapseButton.forEach(button =>
      button.addEventListener('click', this.handleCollapseButtonClick.bind(this))
    );
    this.removeButtons.forEach(button =>
      button.addEventListener('click', this.handleRemoveAllButtonClick.bind(this))
    );

    this.variantOptionTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        this.handleVariantOptionTrigger.call(this, e);
        this.updateAddonVariantSelect();
      });
    });

    // this.atcDummyButton.addEventListener('click', () => {
    //   this.atcRealButton.click();
    // });

    // new  code


    // === Custom ATC handler ===

    const hasAddonSection = document.querySelector('.trellis-product-add-ons') ||
                            this.section?.querySelector('.product-add-on');

    const handleCustomATC = async (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }

      const form = this.section?.closest('form') ||
                   document.querySelector('form[action*="/cart/add"]');

      // Find variant ID
      let mainId = form?.querySelector('input[name="id"]')?.value;

      if (!mainId) {
        document.querySelectorAll('form[action*="/cart/add"]').forEach(f => {
          const id = f.querySelector('input[name="id"]')?.value;
          if (id && !mainId) mainId = id;
        });
      }

      if (!mainId) {
        mainId = document.querySelector('select[name="id"]')?.value;
      }

      if (!mainId) {
        const checkedRadio = document.querySelector(
          'input[data-variant-option-trigger][type="radio"]:checked'
        );
        mainId = checkedRadio?.dataset?.variantId ||
                 checkedRadio?.dataset?.variantid ||
                 checkedRadio?.value;
      }

      if (!mainId) {
        mainId = document.querySelector('[data-variant-id]')?.dataset?.variantId ||
                 document.querySelector('[data-variantid]')?.dataset?.variantid;
      }

      if (!mainId) {
        alert('Please select a variant');
        return;
      }

      // Quantity — robust search
      let qtyInput = null;

      const itgWrapper = document.querySelector('.itg_main_product_quantity');
      if (itgWrapper) {
        qtyInput = itgWrapper.querySelector('input[name="product_quantity"]') ||
                   itgWrapper.querySelector('input[name="quantity"]') ||
                   itgWrapper.querySelector('input[type="number"]') ||
                   itgWrapper.querySelector('input');
      }

      if (!qtyInput) {
        document.querySelectorAll('.quantity-selector').forEach(sel => {
          if (!qtyInput && !sel.closest('.add-on-card')) {
            qtyInput = sel.querySelector('input[name="product_quantity"]') ||
                       sel.querySelector('input[name="quantity"]') ||
                       sel.querySelector('input[type="number"]') ||
                       sel.querySelector('input');
          }
        });
      }

      if (!qtyInput && form) {
        const found = form.querySelector('input[name="quantity"]') ||
                      form.querySelector('input[name="product_quantity"]') ||
                      form.querySelector('input[type="number"]');
        if (found && !found.closest('.add-on-card')) {
          qtyInput = found;
        }
      }

      if (!qtyInput) {
        document.querySelectorAll('input[name="quantity"], input[name="product_quantity"], input[type="number"]').forEach(inp => {
          if (!qtyInput && !inp.closest('.add-on-card')) {
            qtyInput = inp;
          }
        });
      }

      const mainQty = parseInt(qtyInput?.value || '1', 10) || 1;

      // Build items array
      const items = [{ id: mainId, quantity: mainQty }];

      // Addon logic — sirf tab chalega jab addon section ho
      if (hasAddonSection && this.section) {
        this.section
          .querySelectorAll('.product-add-on.expanded .add-on-input:checked')
          .forEach(input => {
            const variantId = input.dataset.addonProduct || input.value;
            const qty = parseInt(input.dataset.addonQuantity || '1', 10) || 1;
            if (variantId && /^\d+$/.test(variantId)) {
              items.push({ id: variantId, quantity: qty });
            }
          });
      }

      // Loading state
      this.atcDummyButton?.classList.add('button--loading');
      this.atcDummyButton?.setAttribute('disabled', 'true');
      this.atcRealButton?.classList.add('button--loading', 'disabled');

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        const data = await res.json();

        if (!res.ok) {
          alert(data.description || 'Could not add to cart');
          return;
        }

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        window.location.href = '/cart';
      } catch (err) {
        alert('Something went wrong, please try again');
      } finally {
        this.atcDummyButton?.classList.remove('button--loading');
        this.atcDummyButton?.removeAttribute('disabled');
        this.atcRealButton?.classList.remove('button--loading', 'disabled');
      }
    };

    // Intercept form submit and button clicks
    const productForm = this.section?.closest('form') ||
                        document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      productForm.addEventListener('submit', handleCustomATC, true);
    }

    this.atcDummyButton?.addEventListener('click', handleCustomATC, true);

    if (this.atcRealButton) {
      this.atcRealButton.addEventListener('click', handleCustomATC, true);
    }


     // new  code



    this.addOnObserver.observe(this.addOnPriceNode, {
      characterData: true,
      childList: true,
      subtree: true
    });

    for (let i = 0; i < this.addOnsContainers.length; i++) {
      const title = this.addOnsContainers[i].dataset.bannerTitle;
      const declineText = this.addOnsContainers[i].dataset.declineText;
      this.selectedAddOnsObject[title] = {
        value: "Please select",
        declineText,
        inputs: this.addOnsContainers[i].querySelectorAll('[data-addon-product]'),
        selectionMade: false
      };
    }
    this.section.querySelectorAll('select[data-index^="addon_option"]').forEach(select => {
      select.addEventListener('change', () => {
       select.closest('.add-on-card').querySelector('.inventory_info')?.classList.add('hide');
        this.getMatchedVariantAndUpdateSelects();
        this.setupAddonPriceUpdate();
      });
    });

    this.section.querySelectorAll('.add-on-input').forEach(input => {
      input.addEventListener('change', () => {
        const currentCard = input.closest('.add-on-card');
        this.section.querySelectorAll('.add-on-card').forEach(card => {
          if (card !== currentCard) {
            card.querySelectorAll('.select-warning').forEach(w => w.remove());
            card.querySelectorAll('.inventory_info').forEach(w => w.classList.add('hide'));
          }
        });

        currentCard.querySelectorAll('select[data-index^="addon_option"]').forEach(select => {
          const opt = select.selectedOptions[0];
          const isValid = opt?.dataset?.variantid;
          const wrapper = select.parentElement.querySelector('.option-title');
          wrapper.querySelector('.select-warning')?.remove();
          if (!isValid) {
            const warn = document.createElement('span');
            warn.className = 'select-warning';
            warn.style.cssText = 'color:red; font-size:10px; display:block; margin-top:4px;';
            warn.textContent = 'Select valid option';
            wrapper.appendChild(warn);
          }
        });

        this.checkATCStatus?.();
        this.setupAddonPriceUpdate();
        this.updatePriceText(); 
        this.handleVariantOptionTrigger(input);
        this.getMatchedVariantAndUpdateSelects();
      });
    });

    this.section.closest('.product-info-area')?.querySelectorAll('.quantity-selector').forEach(wrapper => {
      const input = wrapper.querySelector('input[name="product_quantity"]') ||
                    wrapper.querySelector('input[name="quantity"]');
      if (!input) return;
    
      const update = () => {
        this.updatePriceText();
        this.setupAddonPriceUpdate();
      };
      input.addEventListener('input', update);
      input.addEventListener('change', update);
      wrapper.querySelector('[data-plus]')?.addEventListener('click', update);
      wrapper.querySelector('[data-minus]')?.addEventListener('click', update);
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });

    // --------- main product quantity and price update start ----------//
    const mainProQuantityEle = document.querySelector('.itg_main_product_quantity .quantity-selector');
    if (mainProQuantityEle) {
      const quantityInput = mainProQuantityEle.querySelector('input[name="product_quantity"]') ||
                            mainProQuantityEle.querySelector('input[name="quantity"]');
      if (!quantityInput) return;
      const update = () => {
        const value = quantityInput.value?.trim();
        const mainProQuantity = value !== '' ? parseInt(value, 10) : 1;    
        this.priceContainerProduct?.setAttribute('data-product-quantity', mainProQuantity);
        this.updatePriceText?.();
        this.setupAddonPriceUpdate?.();
      };    
      mainProQuantityEle.querySelector('[data-plus]')?.addEventListener('click', update);
      mainProQuantityEle.querySelector('[data-minus]')?.addEventListener('click', update);
      quantityInput.addEventListener('input', update);    
      quantityInput.addEventListener('change', update);    
      update();
    }

    // --------- main product quantity and price update end ----------//

    document.querySelectorAll('input[data-variant-option-trigger][type="radio"]:checked')
      .forEach(radio => this.handleVariantOptionTrigger(radio));

    this.section.querySelectorAll('.add-addons').forEach(button => {
      button.addEventListener('click', () => {
        this.checkATCStatus();
        this.setupAddonPriceUpdate();
      });
    });
    this.updateAddonVariantSelect();
    this.updateAddOnPricing();
    this.checkATCStatus();
    this.setupAddonPriceUpdate();
    this.updateAddOnsBanner();
  }
    setupAddonPriceUpdate() {     
      const selects = this.section.querySelectorAll('select[data-index^="addon_option"]');
      selects.forEach(select => {
        const handleUpdate = () => {
          const selectedOption = select.selectedOptions[0];
          const variantId = selectedOption?.dataset?.variantid?.trim() || '';
          const variantPrice = selectedOption?.dataset?.variantprice?.trim() || '';
          const variantInventory = selectedOption?.dataset?.variantinventory?.trim() || 0 ;
         const inventory_policy = selectedOption?.dataset?.inventory_policy?.trim();
          const isValid = !!variantId;
    
          const card = select.closest('.add-on-card');
          const input = card?.querySelector('.add-on-input');
          const priceEl = card?.querySelector('.product-prices .product-price');
          const quantityInput = card?.querySelector('.quantity-selector input[name="quantity"]');
          const addonQuantity = parseFloat(quantityInput.value.replace(/[^0-9.]/g, '')) || 1;
          const wrapper = select.parentElement.querySelector('.option-title');
    
          // Clear old warnings
          wrapper?.querySelector('.select-warning')?.remove();
    
          if (!isValid && input.checked) {
            const warn = document.createElement('span');
            warn.className = 'select-warning';
            warn.style.cssText = 'color:red; font-size:10px; display:block; margin-top:4px;';
            warn.textContent = 'Select valid option';
            wrapper?.appendChild(warn);
            return;
          }
    
          // Update input and price
          if (input && input.checked && priceEl) {
            input.dataset.addonProduct = variantId;
            input.value = variantId;
            input.dataset.addonPrice = variantPrice;
            input.dataset.addonQuantity = addonQuantity;
            priceEl.dataset.addonPrice = variantPrice;
            priceEl.textContent = variantPrice;
           
           if ((Number(variantInventory) > 0) && inventory_policy !== "continue") {              
              quantityInput.setAttribute('max', variantInventory);
              if (Number(quantityInput.value) > Number(variantInventory)) {
                quantityInput.value = variantInventory;
              }
            }
          }
    
          this.checkATCStatus?.();
          this.updatePriceText?.();
        };
    
        handleUpdate();
        this.calculateAllAddonsPrice();
      });

  }
    calculateAllAddonsPrice() {
      const selectedAddons = this.section.querySelectorAll(
        '.product-add-on.expanded .add-on-card input.add-on-input[type="checkbox"]:checked'
      );
      let totalPrice = 0;
      selectedAddons.forEach(addon => {
        const price = parseFloat((addon.dataset.addonPrice || '').replace(/[^0-9.]/g, '')) || 0;
        const quantity = parseFloat(addon.dataset.addonQuantity || '1') || 1;
        totalPrice += price * quantity;
      });
      this.priceContainerAddOns.innerText = totalPrice;
      return totalPrice;
    }

    getMatchedVariantAndUpdateSelects() {
      this.section.querySelectorAll('.itg_addon_product_option').forEach(addon => {
        const selects = addon.querySelectorAll('select[data-index^="addon_option"]');
        const selectedValues = Array.from(selects).map(select =>
          select.selectedOptions[0]?.textContent.trim() || ''
        );
        if (selectedValues.includes(''))  return; 
        const combinedTitle = selectedValues.join(' / ');
        const hiddenOptions = addon.querySelectorAll('.hidden_addon_variants option');
    
        const match = Array.from(hiddenOptions).find(opt =>
          opt.dataset.variantTitle?.trim().toLowerCase() === combinedTitle.toLowerCase()
        );
    
        if (match) {
          const matchedId = match.dataset.variantid;
          const matchedPrice = match.dataset.variantprice || null;
          const data_inventory = match.dataset.variant_inventory;
          const inventory_policy = match.dataset.inventory_policy;
          selects.forEach(select => {
            const selectedOption = select.selectedOptions[0];
            if (selectedOption) {
              selectedOption.setAttribute('data-variantid', matchedId);
              if (matchedPrice) {
                selectedOption.setAttribute('data-variantprice', matchedPrice);
                 let inventoryValue = 999;
                if ((Number(data_inventory) > 0) && inventory_policy !== "continue") {
                  inventoryValue = data_inventory;
                }              
                selectedOption.setAttribute('data-variantInventory', inventoryValue);
                selectedOption.setAttribute('data-inventory_policy', inventory_policy);
              }
            }
          });
        } 
      });
    }


  updateAddonVariantSelect() {
    this.productOptions.forEach(option => {
      const title = option.querySelector('.option-title span')?.textContent?.trim();
      const selected = option.querySelector('input[type="radio"]:checked');
      if (!title || !selected) return;

      const selectedLabel = selected.nextElementSibling?.textContent?.trim();
      this.section.querySelectorAll('.itg_addon_product_option .product-option').forEach(addon => {
        const addonTitle = addon.querySelector('.option-title span')?.textContent?.trim();
        const select = addon.querySelector('select');
        if (addonTitle?.includes(title) && select) {
          const match = Array.from(select.options).find(opt => opt.textContent.trim() === selectedLabel);
          if (match) {
            select.value = match.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            this.getMatchedVariantAndUpdateSelects();
           
          }
        }
      });

      option.querySelectorAll('input[type="radio"]').forEach(input => {
        input.removeEventListener('change', this.updateAddonVariantSelectBound);
        input.addEventListener('change',
          this.updateAddonVariantSelectBound = this.updateAddonVariantSelect.bind(this),
          { once: true }
        );
      });
    });
  }

// updateAddOnPricing() {
//   const innerText = this.addOnPriceNode.innerText;
//   this.addOnPriceNode.style.display = innerText.toLowerCase().includes('undefined') ? 'none' : 'inline';
// }

  
updateAddOnPricing() {
  const rawText = this.addOnPriceNode?.textContent || '';
  const cleanText = rawText.toLowerCase().trim();
  const shouldHide = cleanText.includes('undefined') || cleanText === '' || isNaN(parseFloat(cleanText.replace(/[^0-9.]/g, '')));
  this.addOnPriceNode.style.display = shouldHide ? 'none' : 'inline';
  // Safari reflow force
  void this.addOnPriceNode.offsetHeight;
}

  handleExpandButtonClick(event) {
    const button = event.currentTarget;
    const container = button.closest('.product-add-on');
    container.classList.add('expanded');
    button.classList.add('selected');
    button.parentElement.querySelector('.remove-addons').classList.remove('selected');
  }

  handleCollapseButtonClick(event) {
    const button = event.currentTarget;
    const container = button.closest('.product-add-on');
    container.classList.remove('expanded');
    button.classList.add('selected');
    button.parentElement.querySelector('.add-addons').classList.remove('selected');
    this.selectedAddOnsObject[button.dataset.bannerTitle].selectionMade = true;
  }

  handleRemoveAllButtonClick(event) {
    const addonIndex = event.target.dataset.addonIndex;
    const bannerTitle = event.target.dataset.bannerTitle;

    this.addonInputs.forEach(input => {
      if (input.dataset.addonIndex == addonIndex && input.checked == true) {
        input.checked = false;
        const changeEvent = new Event('change', { bubbles: true });
        input.dispatchEvent(changeEvent);
      }
    });

    this.selectedAddOnsObject[bannerTitle].value = this.selectedAddOnsObject[bannerTitle].declineText;
    this.selectedAddOnsObject[bannerTitle].selectionMade = true;
    this.handleCollapseButtonClick(event);
    this.updateAddOnsBanner();
  }

  handleVariantOptionTrigger(input) {
    const target = input?.target || input;
    this.atcDummyButton.classList.add("button--loading");
    this.atcDummyButton.setAttribute('disabled', 'true');
    this.atcRealButton.classList.add('disabled', 'button--loading');
    this.variantSelected = true;

    const index = target.dataset.index;
    const value = target.value;
    const optionText = this.addOnsBanner.querySelector(`p[data-option="${index}"]`);
    if (optionText) optionText.innerText = value;

    this.updatePriceText();
    this.updateAddOnsBanner();
  }

  updateAddOnsBanner() {
    this.atcDummyButton.classList.remove("button--loading");
    this.atcRealButton.classList.remove('button--loading');

    if (this.updateAddOnsFirstRun === true) {
      this.updateAddOnsFirstRun = false;
      return;
    }

    for (let key in this.selectedAddOnsObject) {
      const option = this.selectedAddOnsObject[key];
      let inputChecked = false;
      for (let i = 0; i < option.inputs.length; i++) {
        if (option.inputs[i].checked === true) {
          option.value = option.inputs[i].dataset.productTitle;
          option.selectionMade = true;
          inputChecked = true;
        }
      }

      if (inputChecked === false && option.value !== "Please select") {
        option.value = option.declineText;
      }
    }

    this.bannerItems.forEach(item => {
      const addonTitle = item.dataset.addonTitle;
      if (this.selectedAddOnsObject[addonTitle]) {
        item.querySelector('.selected-add-on').innerText = this.selectedAddOnsObject[addonTitle].value;
      }
    });

    this.includeAddOnsButton.click();
    if (this.includeAddOnsFirstClick === false) this.includeAddOnsButton.click();
    this.includeAddOnsFirstClick = false;

    this.updatePriceText();
    this.checkATCStatus();
  }

  checkATCStatus() {
    this.getMatchedVariantAndUpdateSelects();
    if (!this.variantSelected) {
      this.atcDummyButton.setAttribute('disabled', 'true');
      this.atcRealButton.classList.add('disabled');
      return false;
    }
  
     const expandedAddOns = this.section.querySelectorAll('.product-add-on.expanded');
      for (const addon of expandedAddOns) {
        const isActive = addon.querySelector('.add-addons.selected');
        if (isActive) {
          const checkedCheckbox = addon.querySelector('input[type="checkbox"]:checked');
          if (checkedCheckbox) {
            const addon_checked = checkedCheckbox.closest('.add-on-card');
            const selects = addon_checked.querySelectorAll('select[data-index^="addon_option"]');
            for (const select of selects) {
              const selectedOption = select.selectedOptions[0];
              const isValid = selectedOption?.dataset?.variantid;
              if (!isValid) {
                this.disableATC();
                return;
              }
            }
            // All selects valid
            this.enableATC();
          } else {
            this.disableATC();
            return;
          }
        }
      }
    
      this.enableATC();
  
    for (const key in this.selectedAddOnsObject) {
      if (!this.selectedAddOnsObject[key].selectionMade) {
        this.atcDummyButton.setAttribute('disabled', 'true');
        this.atcRealButton.classList.add('disabled');
        return false;
      }
    }
  
    this.atcDummyButton.removeAttribute('disabled');
    this.atcRealButton.classList.remove('disabled');
    return true;
  }
  disableATC() {
    this.atcDummyButton.setAttribute('disabled', 'true');
    this.atcRealButton?.classList.add('disabled');
  }
  
  enableATC() {
    this.atcDummyButton.removeAttribute('disabled');
    this.atcRealButton?.classList.remove('disabled');
  }

  formatCurrency(value) {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: value % 1 === 0 ? 0 : 2
    });
    return value === 0 ? "" : formatter.format(value);
  }


// updatePriceText() {
//   if (this._priceUpdateRunning) return;

//   this._priceUpdateRunning = true;

//   if (this._priceUpdateTimer) clearTimeout(this._priceUpdateTimer);

//   this._priceUpdateTimer = setTimeout(() => {
//     const getPrice = (el) => {
//       const text = el?.innerText?.toLowerCase() || '';
//       return text.includes('undefined') ? 0 : parseFloat(text.replace(/[^0-9.]/g, '')) || 0;
//     };

//     try {
//       const addOnsPrice = getPrice(this.priceContainerAddOns);
//       const productPrice = getPrice(this.priceContainerProduct);
//       const productQuantity = this.priceContainerProduct.getAttribute('data-product-quantity');
//       const quantity = parseFloat(productQuantity) || 1;
//       const totalPrice = this.formatCurrency(addOnsPrice  + (productPrice * quantity));
//       const realPriceEl = this.atcRealButton?.querySelector('.atc--price');
//       const dummyPriceEl = this.atcDummyButton?.querySelector('.dummy-atc--price');
// console.log('totalPrice',totalPrice);
//       if (dummyPriceEl) dummyPriceEl.innerText = totalPrice;
//       if (realPriceEl) realPriceEl.textContent = totalPrice;
//     } catch (err) {
//       console.error("Error in updatePriceText:", err);
//     }

//     setTimeout(() => {
//       this._priceUpdateRunning = false;
//     }, 100);
//   }, 50);
// }
  
updatePriceText() {
  if (this._priceUpdateRunning) return;
  this._priceUpdateRunning = true;

  if (this._priceUpdateTimer) clearTimeout(this._priceUpdateTimer);

  this._priceUpdateTimer = setTimeout(() => {
    const getPrice = (el) => {
      const text = el?.textContent?.toLowerCase() || '';
      return text.includes('undefined') ? 0 : parseFloat(text.replace(/[^0-9.]/g, '')) || 0;
    };

    try {
      const addOnsPrice = getPrice(this.priceContainerAddOns);
      const productPrice = getPrice(this.priceContainerProduct);
      const productQuantity = this.priceContainerProduct.getAttribute('data-product-quantity');
      const quantity = parseFloat(productQuantity) || 1;
      const totalPrice = this.formatCurrency(addOnsPrice + (productPrice * quantity));

      const realPriceEl = this.atcRealButton?.querySelector('.atc--price');
      const dummyPriceEl = this.atcDummyButton?.querySelector('.dummy-atc--price');

      if (dummyPriceEl) dummyPriceEl.textContent = totalPrice;
      if (realPriceEl) realPriceEl.textContent = totalPrice;

      // Safari specific workaround: trigger reflow
      void this.atcRealButton.offsetHeight;
      void this.atcDummyButton.offsetHeight;
    } catch (err) {
      console.error("Error in updatePriceText:", err);
    }

    setTimeout(() => {
      this._priceUpdateRunning = false;
    }, 100);
  }, 50);
}


  
}
